<template>
  <div class="lock-main">
    <div class="lock-box">
      <div style="text-align: center; font-size: 18px; font-weight: bold; margin-bottom: 32px;">
        页面已上锁，请输入解锁密码
      </div>
      <el-input type="password" size="large" v-model="pwd" placeholder="请输入6位数字" show-password />
      <div class="dialog-footer" style="text-align: center; margin-top: 16px;">
        <el-button @click.native="cancel" >取消</el-button>
        <el-button type="primary" @click="summit">解锁</el-button>
      </div>
    </div>
  </div>


</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {unlockOrLockMenu} from "@/api/url";

export default {
  name: "Lock",
  props: {
    value: Object
  },
  data() {
    return {
      pwd: '',
    }
  },
  methods: {



    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.pwd) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入密码',
          type: 'warning'
        });
        return false
      }
      let param = {}
      param['pwd'] = this.pwd
      param['type'] = 0
      postFormData(unlockOrLockMenu, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.pwd = ''
          // this.$emit('confirm')
          this.$router.go(-1)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },





  },
  mounted() {
  }
}
</script>

<style scoped>
.lock-main {
  width: 100%;
  display: flex;
  justify-content: center;
}
.lock-box {
  width: 400px;
  margin-top: 10%;
  border: 2px solid #ebeef5;
  padding: 40px;
  border-radius: 16px;

}
</style>
